import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery } from 'react-query'
import { SuggestedChecklistsByDocumentType } from '@dc-shared-web/hooks/api/office/types'
import { fetchOfficeSuggestedChecklists } from '@dc-shared-web/hooks/api/office/fetchOfficeSuggestedChecklists'

export const useOfficeSuggestedChecklists = ({
  officeUUID,
  enabled = true,
}: {
  officeUUID: string
  enabled?: boolean
}) => {
  const apiClient = useSvcCrunchesContext()

  return useQuery<SuggestedChecklistsByDocumentType[], Error>(
    ['office', officeUUID, 'suggested-checklists'],
    async () => {
      const documentTypes = await fetchOfficeSuggestedChecklists(apiClient, {
        officeUUID,
      })

      return documentTypes
    },
    {
      enabled,
    }
  )
}
